import { render, staticRenderFns } from "./ClientParameters.vue?vue&type=template&id=038b5e32"
import script from "./ClientParameters.vue?vue&type=script&lang=js"
export * from "./ClientParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports